import { render, staticRenderFns } from "./VirtualDesktopHome.vue?vue&type=template&id=56256a40&scoped=true"
import script from "./VirtualDesktopHome.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopHome.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopHome.vue?vue&type=style&index=0&id=56256a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56256a40",
  null
  
)

export default component.exports